module.exports = __webpack_public_path__ + "static/media/lannister_power.625b3fd7.png";